<template>
  <div class="content apply">
    <van-row>
      <van-col class="slices">
        <img src="../../../static/bg.png">
        <div class="apply1" id="apply1">
          <div style="font-size: .32rem;text-align: center;padding-top: .6rem;">
            免费试用
          </div>
          <div style="font-size: .24rem;text-align: center;padding-top: .1rem;color: #666666FF;">
            客服人员会尽快与您取得联系，安排试用
          </div>
          <van-row style="width: 5.4rem;margin: auto;padding: .6rem 0;">
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialOrganizationName" placeholder="机构名称">
            </van-col>
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialName" placeholder="姓名">
            </van-col>
            <van-col :span="24">
              <input type="text" name="" v-model="param.trialPhone" placeholder="请输入手机号">
            </van-col>
            <van-col :span="14">
              <input type="text" name="" v-model="param.code" placeholder="请输入手机验证码">
            </van-col>
            <van-col :span="1"></van-col>
            <van-col :span="9">
              <!-- <button>获取验证码</button> -->
              <button type="" :disabled="codeDisabled" @click="getCode" v-text="codeText" :class="codeDisabled?'disabled':''"></button>
            </van-col>
            <van-col :span="24" v-if="captchaObj" style="border-color: transparent;border-radius: 0;">
              <div id="captcha"></div>
            </van-col>
            <van-col :span="24" style="margin-top: .35rem;">
              <button @click="submit">立即申请试用</button>
            </van-col>
          </van-row>
        </div>
      </van-col>
    </van-row>
  </div>
</template>
<script>
// import {} from '../../api';
import { getMsgTestCode, submitTrial } from '../../api';
export default {
  name: 'apply',
  data() {
    return {
      param: {
        inviterName: "",
        inviterOpenId: "",
        trialName: "",
        trialOpenId: "",
        trialOrganizationName: "",
        trialPhone: "",
        code: ""
      },
      t: "",
      countdown: 60,
      codeText: "获取验证码",
      codeDisabled: false,
      geetParm: {},
      captchaObj: "",
      needVerificationCode: 0,
      code: "",
      codeId: ""
    }
  },
  methods: {
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]); return "";
    },
    getCode() {
      var that = this;
      if (this.param.trialPhone == null || this.param.trialPhone == "") {
        this.$toast("请输入联系方式!")
        return;
      }
      getMsgTestCode("?tel=" + this.param.trialPhone).then(res => {
        if (res.code == 1) {
          that.$toast("验证码发送成功!");
          that.param.code = res.data.code;
          that.param.codeId = res.data.codeId;
          that.t = window.setInterval(function () {
            that.countdown--;
            if (that.countdown == 0) {
              window.clearInterval(that.t);
              that.codeText = "获取验证码";
              that.countdown = 60;
              that.codeDisabled = false;
            } else {
              that.codeText = that.countdown + "后可重发";
              that.codeDisabled = true;
            }
          }, 1000);
        } else {
          that.$toast(res.message);
        }
      })
    },
    submit() {
      var that = this;
      if (this.param.trialOrganizationName == "") { this.$toast("请输入机构名称！"); return; }
      if (this.param.trialName == "") { this.$toast("请输入联系人姓名！"); return; }
      if (this.param.trialPhone == "") { this.$toast("请输入联系方式！"); return; }
      if (this.param.code == "") { this.$toast("请输入验证码！"); return; }
      submitTrial(this.param).then(function (res) {
        if (res.code == 1) {
          that.$toast("申请成功，我们将尽快联系您！")
        } else {
          that.$toast(res.message);
        }
      })
    }
  },
  mounted() {
    this.param.inviterName = this.getQueryString("nickname");
    this.param.inviterOpenId = this.getQueryString("openid");
    this.param.trialOpenId = sessionStorage.getItem('openId');
  }
}
</script>
<style type="text/css">
.apply .slices {
  position: relative;
}
.apply .slices img {
  width: 100%;
  display: block;
  padding: 0;
  margin: 0;
  border: none;
}
.apply1 {
  width: 7rem;
  height: 8.5rem;
  background-color: #fff;
  box-shadow: 0 0.1rem 0.5rem 0 rgba(37, 147, 125, 0.5);
  border-radius: 0.2rem;
  position: absolute;
  top: 2.8rem;
  left: 0.25rem;
}
.apply input {
  width: 100%;
  height: 0.86rem;
  line-height: 0.86rem;
  font-size: 0.28rem;
  background-color: #fff;
  border-color: #e1e1e1ff;
  border-width: 1px;
  padding-left: 0.3rem;
  margin-bottom: 0.3rem;
  border-radius: 0.1rem;
}
.apply button,
.apply .button {
  width: 100%;
  background-color: #649bff;
  height: 0.86rem;
  line-height: 0.86rem;
  border-radius: 0.1rem;
  text-align: center;
  color: #fff;
  font-size: 0.28rem;
  border-color: #649bff;
  border-width: 0;
  display: inline-block;
}
.apply button.disabled {
  background-color: #dedede;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/views/apply/index.vue


// WEBPACK FOOTER //
// src/views/trial/index.vue